export default {
    CULTURE_CODE: 'culture_code',
};
